import { Circle, ILatLng } from "@ionic-native/google-maps";

export interface CircleOptions {
	center: ILatLng;
    radius: number;
	borderColor?: string;
	borderWidth?: number;
    fillColor?: string;
	clickable?: boolean;

	onclick?: (point: ILatLng, circle: Circle) => void;
	contentTooltip?: string;
}